<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="500px"
    class="responsive"
    title="Reset kết quả chấm"
  >
    <p class="mb-0" style="white-space: normal; word-break: keep-all; overflow-wrap: break-word;">
      Bạn có chắc chắn muốn reset kết quả chấm của học viên {{ studentName }}?
      Sau khi reset, điểm/nhận xét/năng lực đã chấm sẽ bị xóa và trạng thái chuyển về Cần chấm.
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end">
      <button type="button" class="btn btn-light mr-2" :disabled="loading" @click="cancel">Huỷ</button>
      <button type="button" class="btn btn-primary" :disabled="loading" @click="$emit('confirm')">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Xác nhận
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ResetHomeworkMarkDialog',
  props: {
    visible: Boolean,
    studentName: {
      type: String,
      default: ''
    },
    loading: Boolean
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    }
  }
}
</script>
